module.exports = __webpack_public_path__ + "static/media/1.ddf5b0e1.png";